(() => {
  const initReveal = (root = document) => {
    const items = root.querySelectorAll('.fremx-reveal:not([data-fremx-reveal-ready])');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    items.forEach((item, index) => {
      item.dataset.fremxRevealReady = 'true';
      item.style.transitionDelay = `${Math.min(index % 4, 3) * 55}ms`;
      observer.observe(item);
    });
  };

  const initMobileMenu = (root = document) => {
    root.querySelectorAll('.fremx-mobile-menu:not([data-fremx-menu-ready])').forEach((menu) => {
      menu.dataset.fremxMenuReady = 'true';
      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => menu.removeAttribute('open'));
      });
      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') menu.removeAttribute('open');
      });
    });
  };

  const initStickyCart = (root = document) => {
    const bar = root.querySelector('[data-fremx-sticky-cart]');
    if (!bar || bar.dataset.fremxStickyReady === 'true') return;

    const mainSubmit = document.querySelector('product-info .product-form__submit');
    const stickySubmit = bar.querySelector('[data-fremx-sticky-submit]');
    const stickyPrice = bar.querySelector('[data-fremx-sticky-price]');
    const productInfo = document.querySelector('product-info');
    if (!mainSubmit || !stickySubmit) return;

    bar.dataset.fremxStickyReady = 'true';

    const syncState = () => {
      const disabled = mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true';
      stickySubmit.disabled = disabled;
      const mainLabel = mainSubmit.querySelector('span')?.textContent?.trim();
      if (mainLabel) stickySubmit.textContent = mainLabel;

      const visiblePrice =
        productInfo?.querySelector('.price__sale .price-item--sale') ||
        productInfo?.querySelector('.price__regular .price-item--regular');
      if (visiblePrice && stickyPrice) stickyPrice.textContent = visiblePrice.textContent.trim();
    };

    const visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting && window.scrollY > 280;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      },
      { threshold: 0 }
    );

    visibilityObserver.observe(mainSubmit);
    stickySubmit.addEventListener('click', () => {
      syncState();
      if (!stickySubmit.disabled) mainSubmit.click();
    });

    if (productInfo) {
      const stateObserver = new MutationObserver(syncState);
      stateObserver.observe(productInfo, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    syncState();
  };

  const initAll = (root = document) => {
    initReveal(root);
    initMobileMenu(root);
    initStickyCart(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
